export default {
	catalog(state) {
		return state.catalog
	},
}
